import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, of } from 'rxjs';
import { StorageService } from 'src/app/_services/storage.service';
import { environment } from 'src/environments/environment';
const { API_URL,API_URLBLAZE } = environment;

@Injectable({
  providedIn: 'root'
})
export class UserManagementService {

  constructor(private http: HttpClient, private storageService: StorageService, private router: Router) { }

  saveUserGroup(groupData: any) {
    const url = `${API_URL}/group`;
    return this.http.post(url, groupData).pipe(catchError(this.handleError()));
  }

  editUserGroup(groupData: any) {
    const url = `${API_URL}/group/update-group`;
    return this.http.post(url, groupData).pipe(catchError(this.handleError()));
  }

  getUserGroupById(groupId: string) {
    const url = `${API_URL}/group/${groupId}`;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  getUserGroupList() {
    const url = `${API_URL}/group`;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  getUserGroupListNew() {
    const url = `${API_URLBLAZE}/user-management/groups/get-all-groups`;
    // const url = `http://localhost:8104/user-management/groups/get-all-groups`;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  // getUserGroupListByFilter(groupName: string, pageRecords: number, pageNumber: number) {
  //   const url = `${API_URL}/group/get-group?groupName=${groupName}&pageRecords=${pageRecords}&pageNumber=${pageNumber}`;
  //   return this.http.get(url).pipe(catchError(this.handleError()));
  // }

  getUserGroupListByFilter(groupName: string, pageRecords: number, pageNumber: number) {

    return this.http
      .post(
        `${API_URL}/group/get-group`,
        {
          "groupName":groupName,
          "pageRecords":pageRecords,
          "pageNumber":pageNumber
     
        }
      )
  }

  addRole(roleData: any) {
    const url = `${API_URL}/role`;
    return this.http.post(url, roleData).pipe(catchError(this.handleError()));
  }

  updateRole(roleData: any) {
    const url = `${API_URL}/role/update-role`;
    return this.http.post(url, roleData).pipe(catchError(this.handleError()));
  }

  getRoleList(groupId: number) {
    const url = `${API_URL}/role?groupId=${groupId}`;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  getRoleListNew() {
    const url = `${API_URLBLAZE}/user-management/role/get-all-roles`;
    // const url = `http://localhost:8104/user-management/role/get-all-roles`;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  // getRoleListWithFilter(name: string, group: number, status: string, pageRecords: number, pageNumber: number) {
  //   const url = `${API_URL}/role/get-role?name=${name}&group=${group ? group : ''}&status=${status ? status : ''}&pageRecords=${pageRecords}&pageNumber=${pageNumber}`;
  //   return this.http.get(url).pipe(catchError(this.handleError()));
  // }

  getRoleListWithFilter(name: string, group: number, status: string, pageRecords: number, pageNumber: number) {

    return this.http
      .post(
        `${API_URL}/role/get-role`,
        {
          "name":name,
          "group":group,
          "status":status,
          "pageRecords":pageRecords,
          "pageNumber":pageNumber
     
        }
      )
  }


  getPermissionList() {
    const url = `${API_URL}/permission`;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  getDummyPermissions() {
    return this.http.get("assets/dummy-permission.json").pipe(catchError(this.handleError()));
  }

  getStatusList() {
    const url = `${API_URL}/status`;
        // const url = `http://localhost:9091/mo-crm/status`;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  getStatusListNew() {
    const url = `${API_URLBLAZE}/user-management/user/status`;
        // const url = `http://localhost:8104/user-management/user/status`;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  getRoleById(roleId: string) {
    const url = `${API_URL}/role/${roleId}`;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: HttpErrorResponse): Observable<T> => {
      if (error.status == 401) {
        this.storageService.clean()
        this.router.navigate(['/auth/login']);
      }
      result = error?.error;
      return of(result as T);
    };
  }

  getLanguageList() {
    const url = `${API_URL}/language`;
    // const url = `http://localhost:9091/mo-crm/language`;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  getLanguageListNew() {
    const url = `${API_URLBLAZE}/user-management/user/language`;
    // const url = `http://localhost:8104/user-management/user/language`;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  getTimezoneList() {
    const url = `${API_URL}/time-zone`;
    // const url = `http://localhost:9091/mo-crm/time-zone`;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  getTimezoneListNew() {
    const url = `${API_URLBLAZE}/user-management/user/timezone`;
    // const url = `http://localhost:8104/user-management/user/timezone`;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  uploadProfileImage(profileData: any) {
    const url = `${API_URL}/user/profile`;
    return this.http.post(url, profileData).pipe(catchError(this.handleError()));
  }

  saveUser(profileData: any) {
    const url = `${API_URL}/user`;
    return this.http.post(url, profileData).pipe(catchError(this.handleError()));
  }

  saveUserNew(profileData: any) {
    const url = `${API_URLBLAZE}/user-management/user/save`;
    // const url = `http://localhost:8104/user-management/user/save`;
    return this.http.post(url, profileData).pipe(catchError(this.handleError()));
  }

  updateUser(profileData: any) {
    const url = `${API_URL}/user/edit`;
    return this.http.post(url, profileData).pipe(catchError(this.handleError()));
  }

  updateUserNew(profileData: any) {
    const url = `${API_URLBLAZE}/user-management/user/update`;
    // const url = `http://localhost:8104/user-management/user/update`;
    return this.http.post(url, profileData).pipe(catchError(this.handleError()));
  }
  // getUserList(email: string, group: number, status: number, role: number, pageRecords: number, pageNumber: number) {
  //   const url = `${API_URL}/user/get-user?emailId=${email}&role=${role ? role : ''}&group=${group ? group : ''}&status=${status ? status : ''}&pageRecords=${pageRecords}&pageNumber=${pageNumber}`;
  //   return this.http.get(url).pipe(catchError(this.handleError()));
  // }

  getUserList(email: string, group: number, status: number, role: number, pageRecords: number, pageNumber: number) {
    let payload: any = {
      pageRecords: pageRecords,
      pageNumber: pageNumber
    }
    if (email && email.trim() !== '') {
      payload.emailId = email;
    }  
    if(role && role!=null){
    payload.roleId= role
    }
    if(group && group!=null){
      payload.groupId=group
    }
    if(status && status!=null){
      payload.status=status
    }

    return this.http
      .post(
        `${API_URL}/user-management/user/getList`,
        // `http://localhost:8104/user-management/user/getList`,
        payload
      )
  }

  getUserListNew(pageRecords: number,pageNumber: any, dateFrom: String, dateTo: String, customerId: string, transactionId: string, type: string) {
    var url = "";
      const payload:any = {};
      if (customerId != null) payload.customerId = customerId;
      if (pageRecords != null) payload.pageRecords = pageRecords;
      if (pageNumber != null) payload.pageNumber = pageNumber;
      if (transactionId != null) payload.transactionId = transactionId;
      if (dateFrom != null) payload.dateFrom = dateFrom;
      if (dateTo != null) payload.dateTo = dateTo;
    url = `${API_URLBLAZE}/user-management/user/getList`;
    // url = `http://localhost:8104/user-management/user/getList`;
    return this.http.post(url,payload).pipe(catchError(this.handleError()));
  }

  fetchImage(urlImg: string) {
    const url = `${API_URL}/user/get-profile?url=${urlImg}`;
    return this.http.get(url, { responseType: 'blob' as 'json' }).pipe(catchError(this.handleError()));
  }

  getUserByEmail(email: string) {
    const url = `${API_URL}/user/${email}`;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  getUserByEmailNew(email: string) {
    const url = `${API_URLBLAZE}/user-management/user/get/${email}`;
    // const url = `http://localhost:8104/user-management/user/get/${email}`;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  updateUserStatus(emailId: string, status: number) {
    const url = `${API_URL}/user-management/user/update-status?emailId=${emailId}&status=${status}`;
    // const url = `http://localhost:8104/user-management/user/update-status?emailId=${emailId}&status=${status}`;
    return this.http.post(url, {}).pipe(catchError(this.handleError()));
  }

  getPermissionByRoleId(roleId: number) {
    const url = `${API_URL}/permission/${roleId}`;
    return this.http.get(url).pipe(catchError(this.handleError()));
  }

  updatePermissionByRoleId(permissionData: any) {
    const url = `${API_URL}/role/update-permission`;
    return this.http.post(url, permissionData).pipe(catchError(this.handleError()));
  }

  resetTfa(emailId: string) {
    const url = `${API_URL}/user/reset-tfa?emailId=${emailId}`;
    return this.http.post(url, {}).pipe(catchError(this.handleError()));
  }

}
